<template>
  <sweet-modal overlay-theme="dark" ref="modal">
    <div class="flex flex-col">
      <p class="font-medium text-lg">{{ title }}</p>
      <p class="mt-2 text-grey-darker" v-if="body">{{ body }}</p>

      <div class="mt-6 flex justify-center">
        <button
          type="button"
          class="border border-grey bg-white px-6 py-2 text-grey-darker rounded font-medium mr-2 hover:bg-grey-lightest"
          @click.prevent="close"
        >
          {{ cancelLabel }}
        </button>
        <button
          type="button"
          class="border border-red bg-red px-6 py-2 text-white rounded font-medium hover:bg-red-dark"
          @click.prevent="confirm"
        >
          {{ actionLabel }}
        </button>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
/**
 * "Cancel / Do it" confirmation in the round 2 style (see the cancel
 * invitation dialog in InvitedMembers.vue). Open it through a ref:
 * this.$refs.confirm.open(); it closes itself and emits `confirm`.
 */
export default {
  name: "ConfirmDialog",

  props: {
    title: { type: String, required: true },
    body: { type: String, default: "" },
    actionLabel: { type: String, default: "Delete" },
    cancelLabel: { type: String, default: "Cancel" },
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },

    close() {
      this.$refs.modal.close();
    },

    confirm() {
      this.close();
      this.$emit("confirm");
    },
  },
};
</script>
